import {fromJS, List} from 'immutable'

import {
  CONVERSATION_PANE_STATUSES
} from '../../config/constants'

const newConv = (conversationId, targetId, type) => {
  return {
    conversationId,
    targetId,
    type,
    status: CONVERSATION_PANE_STATUSES.OPEN
  }
}

const existingConversation = (convId, conv) => conv.get('conversationId') === convId

const shiftFocusedConvToPosition = (focusedIndex, stack) => {
  const focusedConv = typeof(focusedIndex) === 'number' ? stack.get(focusedIndex + 1) : null

  if (focusedConv) {
    stack = stack.delete(focusedIndex + 1)
    stack = stack.insert(focusedIndex, focusedConv)
  }

  return stack
}

const addNewConversationToStack = (conv, focusedIndex, stack) => {
  stack = stack.unshift(conv)
  stack = shiftFocusedConvToPosition(focusedIndex, stack)

  return stack
}

const repositionExistingConversation = (index, focusedIndex, type, stack) => {
  const conv = stack.get(index).set('type', type)
  stack = stack.delete(index).unshift(conv)
  stack = shiftFocusedConvToPosition(focusedIndex, stack)

  return stack
}

export default (conversationId, targetId, focusedIndex, visibleSlot, type, stack) => {
  if (typeof(stack) === 'undefined' || stack === null) stack = fromJS([])
  if (!List.isList(stack)) stack = fromJS(stack)
  if (!conversationId) return stack

  // check exists in stack
  const index = stack.findKey(existingConversation.bind(null, conversationId))
  if (typeof(index) !== 'number' || index < 0) return addNewConversationToStack(newConv(conversationId, targetId, type), focusedIndex, stack)
  if (index === focusedIndex) return stack
  if (index < visibleSlot) return stack
  else return repositionExistingConversation(index, focusedIndex, type, stack)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/helpers/add_conversation_to_stack.js
 **/